import { styled } from '@mui/material/styles'

export const BlockToolbar = styled('div')(({ theme }) => ({
  width: 18,
  height: 18,
  position: 'absolute',
  left: theme.spacing(1),
  pointerEvents: 'auto',
}))
